import { createContext } from 'react';
// -*- mode: jsx;-*-

// If no tracking functions are provided, our view-tracking code will just no-op by default
export const ViewTrackingContext = createContext(() => {});
